module.exports = __webpack_public_path__ + "img/logo_Chubb.4f490a75.svg";